"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotEnoughDataMessage = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const need_more_info_warning_1 = __importDefault(require("../../../components/need-more-info-warning"));
const business_address_1 = __importDefault(require("../../../components/business-address"));
const bureaus_1 = require("../../../utils/bureaus");
const GetStartedLink = (0, styled_components_1.default)(base_react_components_1.Button).withConfig({ displayName: "reports-GetStartedLink", componentId: "reports-blevni" }) `
  align-self: center;
  margin-bottom: 16px;
  white-space: nowrap;
`;
const InputWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-InputWrapper", componentId: "reports-61cvqb" }) `
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
`;
const NotMyBusinessLink = (0, styled_components_1.default)(base_react_components_1.Button).attrs(() => ({
    variation: 'outline',
})).withConfig({ displayName: "reports-NotMyBusinessLink", componentId: "reports-1iwmtd3" }) `
  margin-bottom: 16px;
  margin-right: 16px;
  white-space: nowrap;
`;
const NotEnoughDataMessage = (_a) => {
    var _b, _c;
    var { bureauSlug, businessAddress, isPartnerCreditSuite } = _a, props = __rest(_a, ["bureauSlug", "businessAddress", "isPartnerCreditSuite"]);
    const { 'data-testid': dataTestId } = props;
    return (react_1.default.createElement(need_more_info_warning_1.default, { title: "Not enough data to generate a credit score for:", dataTestId: dataTestId },
        react_1.default.createElement(business_address_1.default, Object.assign({}, businessAddress)),
        react_1.default.createElement(base_react_components_1.Copy, null, (_c = (_b = (0, bureaus_1.getBureau)(bureauSlug)) === null || _b === void 0 ? void 0 : _b.displayName) !== null && _c !== void 0 ? _c : 'This bureau',
            " has some data on your business, but not enough to generate a credit score yet. This could keep your business from qualifying for low-cost financing options."),
        !isPartnerCreditSuite && (react_1.default.createElement(base_react_components_1.Copy, null, "We\u2019ve made a simple, 3-step guide to help you establish a business credit score.")),
        react_1.default.createElement(InputWrapper, null,
            react_1.default.createElement(base_react_components_1.Link, { "data-testid": `premium-${bureauSlug}-overview-not-my-business-link`, to: `/partner/business-match/${bureauSlug}` },
                react_1.default.createElement(NotMyBusinessLink, null, "This is not my business")),
            !isPartnerCreditSuite && (react_1.default.createElement(base_react_components_1.Link, { to: "/partner/education/tradeline" },
                react_1.default.createElement(GetStartedLink, null, "Get started"))))));
};
exports.NotEnoughDataMessage = NotEnoughDataMessage;
exports.default = exports.NotEnoughDataMessage;
//# sourceMappingURL=not-enough-data-message.js.map